<template>
  <div class="space-y-4" role="list">
    <DefaultSettingRow
      title="注文弁当"
      :label="purchaseLog.menu_name"
      :value="purchaseLog.menu_id"
      :default-value="data?.default_menu?.id ?? null"
      role="list-item"
      @set-default="setDefault('default_menu_id', $event)"
    />
    <DefaultSettingRow
      title="個数"
      :label="`${purchaseLog.quantity}`"
      :value="purchaseLog.quantity"
      :default-value="data?.default_quantity ?? null"
      role="list-item"
      @set-default="setDefault('default_quantity', $event)"
    />
    <DefaultSettingRow
      title="支払い方法"
      :label="paymentMethodDisplay"
      :value="purchaseLog.payment_method"
      :default-value="data?.default_payment_method ?? null"
      role="list-item"
      @set-default="setDefault('default_payment_method', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { getPaymentMethodDisplay } from '~/utils/purchase';

import type { PurchaseLogSchema } from '~/schemas/purchase_log_schema';
import type { DefaultPurchaseSettingSchema } from '~/schemas/default_purchase_setting';

const { log: purchaseLog } = defineProps<{
  log: PurchaseLogSchema;
}>();

const auth = useAuth();
const config = useRuntimeConfig();

const { data, refresh } = await useAsyncData(
  async () =>
    await $fetch<DefaultPurchaseSettingSchema>('/default-purchase-setting/', {
      method: 'GET',
      headers: {
        Authorization: auth.tokenStrategy.token?.get()?.toString() ?? '',
        'Content-Type': 'application/json',
      },
      baseURL: config.public.BASE_URL,
    }),
);

const paymentMethodDisplay = computed(() => {
  return getPaymentMethodDisplay(purchaseLog.payment_method);
});

const setDefault = async (column: string, value: string | number) => {
  await $fetch('/default-purchase-setting/', {
    method: 'PATCH',
    headers: {
      Authorization: auth.tokenStrategy.token?.get()?.toString() ?? '',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      [column]: value,
    }),
    baseURL: config.public.BASE_URL,
  });
  refresh();
};
</script>
